module.exports = __webpack_public_path__ + "img/level_other.a3ffaccd.png";